import type { Alert, AlertGroup } from '../hooks/useAlerts'
import { todayAlertHeading } from './todayAlertHeading'
import { priceGroupSummary, priceMoney } from './todayPriceGroups'

// The top card must identify the actual update, never only a rival + percentage.
export function topUpdateContext(alert: Alert, group?: AlertGroup) {
  const summary = group && group.alerts.length > 1 && group.alerts.some(member => member.id === alert.id)
    ? priceGroupSummary(group.alerts) : null
  if (summary && group) return { title: summary.title, product: null, prices: null,
    groupId: group.id, actionLabel: `View ${group.alerts.length} ${summary.noun} →` }
  const isPrice = alert.alert_type === 'price_drop' || alert.alert_type === 'price_increase'
  const comparable = typeof alert.old_value === 'string' && typeof alert.new_value === 'string' &&
    alert.old_value.trim() !== '' && alert.new_value.trim() !== '' &&
    Number.isFinite(Number(alert.old_value)) && Number.isFinite(Number(alert.new_value))
  return {
    title: todayAlertHeading({ ...alert, entity_brand: alert.entity_brand?.trim() || 'Brand not specified' }).title,
    product: alert.entity_name?.trim() || (isPrice ? 'Product not specified in source' : null),
    prices: isPrice ? comparable ? `${priceMoney(alert.old_value)} → ${priceMoney(alert.new_value)}` : 'Price comparison unavailable' : null,
    groupId: null, actionLabel: 'Review source alert →',
  }
}
